<script>
	import { Parallax, ParallaxLayer, StickyLayer } from 'svelte-parallax'
	import { Pinterest, Facebook, Twitter, Line } from 'svelte-share-buttons-component';
	import Youtube from "svelte-youtube-embed";
	import "./app.css";

	const url = 'https://716.pages.dev/';

	let parallax;
	let doremi = 'doremi'.split('');
	let nanairo = 'nanairo'.split('');
</script>

<Parallax sections={5.5} bind:this={parallax}>

	<ParallaxLayer offset={1} rate={-2.5} style="display: flex; justify-content: flex-end;">
		<div style="background-color: lightblue; opacity: 0.5; width: 50%; height: 100%;"/>
	</ParallaxLayer>

	<ParallaxLayer offset={1} rate={2.5} style="display: flex; justify-content: flex-start;">
		<div style="background-color: yellow; opacity: 0.5; width: 50%; height: 100%;"/>
	</ParallaxLayer>

	<ParallaxLayer rate={-0.4} offset={0.3}>
		<img
				src="/onpu.png"
				alt="score card"
				style="
				   display: flex;
				   justify-content: center;
				   align-items: center;"
		/>
	</ParallaxLayer>

	<ParallaxLayer
			rate=1
			style="
		  background-color: pink;
			display: flex;
			justify-content: center;
			align-items: center;
			flex-direction: column;
		"
	>
		<div class="video">
			<video src="/doremi_dance.mp4" autoplay loop muted playsinlin></video>
		</div>
		<img
				src="/doremi_logo.png"
				alt="logo"
				style="
				   display: flex;
				   justify-content: center;
				   align-items: center;
                   width: 45%"
		/>
		<a href="#" class="scroll-down" on:click={() => parallax.scrollTo(3.7, { selector: '#doremi', duration: 8000 })}>
			<div class="scroll">
				<span class="scroll-dot"></span>
			</div>
			<div class="allow-down">

			</div>
		</a>
	</ParallaxLayer>

	{#each doremi as char, index (index)}
		<ParallaxLayer
				rate={(index + 1) / (doremi.length - 1)}
				offset={1}
				style="
			  margin-left: {38 + (index * 5)}%;
				display: flex;
				justify-content: flex-start;
				align-items: center;
		  "
		>
			<p class="fancy">
				{char}
			</p>
		</ParallaxLayer>
	{/each}

	{#each nanairo as char, index (index)}
		<ParallaxLayer
				rate={(index + 1) / (nanairo.length - 1)}
				offset={1.1}
				style="
			  margin-left: {38 + (index * 5)}%;
				display: flex;
				justify-content: flex-start;
				align-items: center;
		  "
		>
			<p class="fancy">
				{char}
			</p>
		</ParallaxLayer>
	{/each}

	<ParallaxLayer offset={1} rate={1.5} let:progress>
		<img
				src="/kirakira.png"
				alt="kirakira"
				style="
				   display: flex;
				   justify-content: center;
				   align-items: center;
				   width: 10%;
				   margin-top: 20%;
				   margin-left: calc(100% - {progress * 90}%);
                   transform: rotate({progress * 360}deg)"
		/>
	</ParallaxLayer>

	<ParallaxLayer offset={1.1} rate={1.5} let:progress>
		<img
				src="/kirakira.png"
				alt="kirakira"
				style="
				   display: flex;
				   justify-content: center;
				   align-items: center;
				   width: 10%;
				   margin-top: 20%;
				   margin-left: calc(100% - {progress * 80}%);
                   transform: rotate({progress * 360}deg)"
		/>
	</ParallaxLayer>

	<ParallaxLayer offset={2.5} rate={1.5} let:progress style="display: flex; justify-content: flex-start;">
		<div style="background-color: rgb({255 - progress * progress * progress * progress * 60}, 255, 0);; opacity: 0.5; width: 100%; height: 230%;"/>
	</ParallaxLayer>

<!--	Parallax50/50-->
	<ParallaxLayer offset={4.3} rate={-2.5} style="display: flex; justify-content: flex-end; pointer-events: none;">
		<div style="background-color: lightblue; opacity: 0.5; width: 50%; height: 100%;"/>
	</ParallaxLayer>

	<ParallaxLayer offset={4} rate={2.5} style="display: flex; justify-content: flex-start; pointer-events: none;">
		<div style="background-color: rgb(255, 255, 0); opacity: 0.5; width: 50%; height: 100%;"/>
	</ParallaxLayer>

<!--	音符parallax-->
	<ParallaxLayer offset={2} rate={1.5} let:progress>
		<img
				src="/77131.png"
				alt="onpu"
				style="
				   display: flex;
				   justify-content: center;
				   align-items: center;
				   width: 5%;
				   margin-left: calc(100% - {progress * 90}%);
                   transform: rotate({progress * 360}deg)"
		/>
	</ParallaxLayer>

	<ParallaxLayer offset={2} rate={1.5} let:progress>
		<img
				src="/77132.png"
				alt="onpu"
				style="
				   display: flex;
				   justify-content: center;
				   align-items: center;
				   width: 5%;
				   margin-right: calc(100% - {progress * 100}%);
                   transform: rotate({progress * 60}deg)"
		/>
	</ParallaxLayer>

	<ParallaxLayer offset={2.3} rate={3.5} let:progress>
		<img
				src="/77133.png"
				alt="onpu"
				style="
				   display: flex;
				   justify-content: flex-end;
				   align-items: center;
				   width: {5 + progress * 10}%;
				   margin-left: calc(100% - {progress * 100}%);
                   transform: rotate({progress * 360}deg)"
		/>
	</ParallaxLayer>

	<ParallaxLayer offset={2.3} rate={1.5} let:progress>
		<img
				src="/77134.png"
				alt="onpu"
				style="
				   display: flex;
				   justify-content: center;
				   align-items: center;
				   width: {5 + progress * 10}%;
				   margin-left: calc(0% + {progress * 100}%);
                   transform: rotate({progress * 60}deg)"
		/>
	</ParallaxLayer>

	<ParallaxLayer offset={2.1} rate={1.5} let:progress>
		<img
				src="/77135.png"
				alt="onpu"
				style="
				   display: flex;
				   justify-content: center;
				   align-items: center;
				   width: 5%;
				   margin-left: calc(100% - {progress * 90}%);
                   transform: rotate({progress * 360}deg)"
		/>
	</ParallaxLayer>

	<ParallaxLayer offset={2.1} rate={1.5} let:progress>
		<img
				src="/77136.png"
				alt="onpu"
				style="
				   display: flex;
				   justify-content: center;
				   align-items: center;
				   width: 5%;
				   margin-right: calc(100% - {progress * 100}%);
                   transform: rotate({progress * 60}deg)"
		/>
	</ParallaxLayer>

	<ParallaxLayer offset={2.5} rate={3.5} let:progress>
		<img
				src="/77137.png"
				alt="onpu"
				style="
				   display: flex;
				   justify-content: flex-end;
				   align-items: center;
				   width: {5 + progress * 10}%;
				   margin-left: calc(100% - {progress * 100}%);
                   transform: rotate({progress * 360}deg)"
		/>
	</ParallaxLayer>

	<ParallaxLayer offset={2.7} rate={1.5} let:progress>
		<img
				src="/77136.png"
				alt="onpu"
				style="
				   display: flex;
				   justify-content: center;
				   align-items: center;
				   width: 5%;
				   margin-right: calc(100% - {progress * 100}%);
                   transform: rotate({progress * 60}deg)"
		/>
	</ParallaxLayer>

	<ParallaxLayer offset={2.8} rate={3.5} let:progress>
		<img
				src="/77137.png"
				alt="onpu"
				style="
				   display: flex;
				   justify-content: flex-end;
				   align-items: center;
				   width: {5 + progress * 10}%;
				   margin-left: calc(100% - {progress * 100}%);
                   transform: rotate({progress * 360}deg)"
		/>
	</ParallaxLayer>

	<ParallaxLayer offset={2.9} rate={1.5} let:progress>
		<img
				src="/77131.png"
				alt="onpu"
				style="
				   display: flex;
				   justify-content: center;
				   align-items: center;
				   width: 5%;
				   margin-right: calc(100% - {progress * 100}%);
                   transform: rotate({progress * 60}deg)"
		/>
	</ParallaxLayer>

	<ParallaxLayer offset={2.9} rate={1.2} let:progress>
		<img
				src="/77111.png"
				alt="onpu"
				style="
				   display: flex;
				   justify-content: flex-end;
				   align-items: center;
				   width: {5 + progress * 10}%;
				   margin-left: calc(100% - {progress * 100}%);
                   transform: rotate({progress * 360}deg)"
		/>
	</ParallaxLayer>

	<ParallaxLayer offset={2.5} rate={1.5} let:progress>
		<img
				src="/77112.png"
				alt="onpu"
				style="
				   display: flex;
				   justify-content: center;
				   align-items: center;
				   width: {5 + progress * 10}%;
				   margin-left: calc(0% + {progress * 100}%);
                   transform: rotate({progress * 60}deg)"
		/>
	</ParallaxLayer>

	<ParallaxLayer offset={2.5} rate={1.3} let:progress>
		<img
				src="/77135.png"
				alt="onpu"
				style="
				   display: flex;
				   justify-content: center;
				   align-items: center;
				   width: {5 + progress * 10}%;
				   margin-left: calc(0% + {progress * 100}%);
                   transform: rotate({progress * 60}deg)"
		/>
	</ParallaxLayer>


<!--	音符parallax offset3-->

	<ParallaxLayer offset={3.2} rate={1.5} let:progress>
		<img
				src="/77131.png"
				alt="onpu"
				style="
				   display: flex;
				   justify-content: center;
				   align-items: center;
				   width: 5%;
				   margin-left: calc(100% - {progress * 90}%);
                   transform: rotate({progress * 360}deg)"
		/>
	</ParallaxLayer>

	<ParallaxLayer offset={3.2} rate={1.5} let:progress>
		<img
				src="/77132.png"
				alt="onpu"
				style="
				   display: flex;
				   justify-content: center;
				   align-items: center;
				   width: 5%;
				   margin-right: calc(100% - {progress * 100}%);
                   transform: rotate({progress * 60}deg)"
		/>
	</ParallaxLayer>

	<ParallaxLayer offset={3.3} rate={3.5} let:progress>
		<img
				src="/77133.png"
				alt="onpu"
				style="
				   display: flex;
				   justify-content: flex-end;
				   align-items: center;
				   width: {5 + progress * 10}%;
				   margin-left: calc(100% - {progress * 100}%);
                   transform: rotate({progress * 360}deg)"
		/>
	</ParallaxLayer>

	<ParallaxLayer offset={3.3} rate={1.5} let:progress>
		<img
				src="/77134.png"
				alt="onpu"
				style="
				   display: flex;
				   justify-content: center;
				   align-items: center;
				   width: {5 + progress * 10}%;
				   margin-left: calc(0% + {progress * 100}%);
                   transform: rotate({progress * 60}deg)"
		/>
	</ParallaxLayer>

	<ParallaxLayer offset={3.1} rate={1.5} let:progress>
		<img
				src="/77135.png"
				alt="onpu"
				style="
				   display: flex;
				   justify-content: center;
				   align-items: center;
				   width: 5%;
				   margin-left: calc(100% - {progress * 90}%);
                   transform: rotate({progress * 360}deg)"
		/>
	</ParallaxLayer>

	<ParallaxLayer offset={3.1} rate={1.5} let:progress>
		<img
				src="/77136.png"
				alt="onpu"
				style="
				   display: flex;
				   justify-content: center;
				   align-items: center;
				   width: 5%;
				   margin-right: calc(100% - {progress * 100}%);
                   transform: rotate({progress * 60}deg)"
		/>
	</ParallaxLayer>

	<ParallaxLayer offset={3.3} rate={3.5} let:progress>
		<img
				src="/77137.png"
				alt="onpu"
				style="
				   display: flex;
				   justify-content: flex-end;
				   align-items: center;
				   width: {5 + progress * 10}%;
				   margin-left: calc(100% - {progress * 100}%);
                   transform: rotate({progress * 360}deg)"
		/>
	</ParallaxLayer>

	<ParallaxLayer offset={3.5} rate={1.5} let:progress>
		<img
				src="/77136.png"
				alt="onpu"
				style="
				   display: flex;
				   justify-content: center;
				   align-items: center;
				   width: 5%;
				   margin-right: calc(100% - {progress * 100}%);
                   transform: rotate({progress * 60}deg)"
		/>
	</ParallaxLayer>

	<ParallaxLayer offset={3.6} rate={3.5} let:progress>
		<img
				src="/77137.png"
				alt="onpu"
				style="
				   display: flex;
				   justify-content: flex-end;
				   align-items: center;
				   width: {5 + progress * 10}%;
				   margin-left: calc(100% - {progress * 100}%);
                   transform: rotate({progress * 360}deg)"
		/>
	</ParallaxLayer>

	<ParallaxLayer offset={3.5} rate={1.5} let:progress>
		<img
				src="/77131.png"
				alt="onpu"
				style="
				   display: flex;
				   justify-content: center;
				   align-items: center;
				   width: 5%;
				   margin-right: calc(100% - {progress * 100}%);
                   transform: rotate({progress * 60}deg)"
		/>
	</ParallaxLayer>

	<ParallaxLayer offset={3.4} rate={1.2} let:progress>
		<img
				src="/77111.png"
				alt="onpu"
				style="
				   display: flex;
				   justify-content: flex-end;
				   align-items: center;
				   width: {5 + progress * 10}%;
				   margin-left: calc(100% - {progress * 100}%);
                   transform: rotate({progress * 360}deg)"
		/>
	</ParallaxLayer>

	<ParallaxLayer offset={3.5} rate={1.5} let:progress>
		<img
				src="/77112.png"
				alt="onpu"
				style="
				   display: flex;
				   justify-content: center;
				   align-items: center;
				   width: {5 + progress * 10}%;
				   margin-left: calc(0% + {progress * 100}%);
                   transform: rotate({progress * 60}deg)"
		/>
	</ParallaxLayer>

	<ParallaxLayer offset={3.5} rate={1.3} let:progress>
		<img
				src="/77135.png"
				alt="onpu"
				style="
				   display: flex;
				   justify-content: center;
				   align-items: center;
				   width: {5 + progress * 10}%;
				   margin-left: calc(0% + {progress * 100}%);
                   transform: rotate({progress * 60}deg)"
		/>
	</ParallaxLayer>


<!--	どれみちゃん全身-->
	<ParallaxLayer rate={0.01} offset={2.5} let:progress
				   style="
				   display: flex;
				   justify-content: center;
				   align-items: center;">
		<img
				src="/doremi.png"
				alt="doremi"
				id="doremi"
				style="
								   display: flex;
				   justify-content: center;
				   align-items: center;
				   width: 100%;
				   margin-right: {progress * 60}%;
				   margin-top: {progress * 180}%;"
		/>
	</ParallaxLayer>

<!--	自己紹介シート-->
	<ParallaxLayer rate={0.1} offset={2.9} let:progress
				   style="
				   display: flex;
				   justify-content: center;
				   align-items: flex-start;">
		<img
				src="/self.png"
				alt="doremi introduce"
				style="
				   display: flex;
				   justify-content: center;
				   align-items: center;
				   margin-left: 40%;
				   width: 50%;
				   margin-top: {progress * progress * 10}%;
　　　　　　　　　　　 opacity: {progress * progress * 10}"
		/>
	</ParallaxLayer>

<!--	YouTube紹介動画-->
	<ParallaxLayer rate={0.25} offset={3.6} let:progress
				   style="
				   display: flex;
				   flex-direction: column;
				   justify-content: center;
				   width: 40%;
				   margin-left: 50%;">
		<h3>1分ちょっとでわかるどれみちゃんのうた</h3>
		<Youtube id="gF_HTZ1zi3g" --title-color="#ffffff00" --title-shadow-color="#00000000">
			<button class="playbtn">♪</button>
		</Youtube>
	</ParallaxLayer>

<!--	おといあわせ-->
	<ParallaxLayer rate={0.2} offset={4} let:progress
				   style="
				   display: flex;
				   flex-direction: column;
				   justify-content: center;
				   align-items: center;
				   width: 40%;
                   margin-left: 50%;
                   pointer-events: none;">
		<h2 style="pointer-events: auto">お問合せは<br><a href="https://twitter.com/716doremi" target="_blank" rel="noopener noreferrer">Twitter DM</a>まで♪</h2>
	</ParallaxLayer>

<!--	Share box-->
	<ParallaxLayer rate={0.1} offset={4.7} let:progress
				   style="
				   display: flex;
				   flex-direction: column;
				   justify-content: center;
				   align-items: center;
                   margin-left: 10%">
		<h2>〜Share me〜</h2>
		<div style="flex-direction: row">
			<Facebook class="share-button" quote="七色どれみ♪" {url} />
			<Twitter class="share-button" text="七色どれみ♪" {url} hashtags="どれみらいぶ" via="716doremi" related="other,users" />
			<Line class="share-button" {url} />
			<Pinterest class="share-button" {url} media="https://716.pages.dev/doremi_logo.png" description="七色どれみ♪" />
		</div>
	</ParallaxLayer>

<!--	右サイドバー Official バナー-->
	<StickyLayer offset={{ top: 0, bottom: 5 }} style="position: relative; pointer-events: none;">
		<a href="https://www.youtube.com/channel/UC5Sg65pntB2V2JBrZdESh1g" target="_blank" rel="noopener noreferrer" >
			<img
					src="/btn_youtube_pc.png"
					alt="official youtube"
					style="
					display: flex;
					justify-content: center;
				    margin-top: 10%;
				    position: absolute;
                    right: 0;
				    align-items: center;
                    height: 20%;
                    pointer-events: auto;"
			/>
		</a>

		<a href="https://twitter.com/716doremi" target="_blank" rel="noopener noreferrer">
			<img
					src="/btn_twitter_pc.png"
					alt="official twitter"
					style="
				    display: flex;
				    justify-content: space-around;
				    align-items: center;
				    position: absolute;
                    right: 0;
                    bottom:  0;
                    height: 20%;
                    margin-bottom: 10%;
                    pointer-events: auto;"
			/>
		</a>
	</StickyLayer>

</Parallax>

<style>
	:global(body) {
		padding: 0;
		background-color: #0bdb8c;
		color: #313131;
		font-family: monospace;
	}

	h1 {
		font-family: 'Kiwi Maru', serif;
		font-size: 2rem;
	}

	h2 {
		font-size: 2rem;
		font-family: 'Kiwi Maru', serif;
	}

	h3 {
		font-size: 1.5rem;
		font-family: 'Kiwi Maru', serif;
	}

	button {
		font-size: 1rem;
		cursor: pointer;
	}

	button:focus {
		outline: 4px dashed #ff5c77;
	}

	.playbtn {
		background: #34d98f;
		background-image: -webkit-linear-gradient(top, #34d98f, #2980b9);
		background-image: -moz-linear-gradient(top, #34d98f, #2980b9);
		background-image: -ms-linear-gradient(top, #34d98f, #2980b9);
		background-image: -o-linear-gradient(top, #34d98f, #2980b9);
		background-image: linear-gradient(to bottom, #34d98f, #2980b9);
		-webkit-border-radius: 23px;
		-moz-border-radius: 23px;
		border-radius: 23px;
		text-shadow: 4px 1px 3px #666666;
		-webkit-box-shadow: 0px 1px 3px #666666;
		-moz-box-shadow: 0px 1px 3px #666666;
		box-shadow: 0px 1px 3px #666666;
		color: #ffffff;
		font-size: 39px;
		padding: 10px 20px 10px 20px;
		text-decoration: none;
	}

	.playbtn:hover {
		background: #3cb0fd;
		background-image: -webkit-linear-gradient(top, #3cb0fd, #3498db);
		background-image: -moz-linear-gradient(top, #3cb0fd, #3498db);
		background-image: -ms-linear-gradient(top, #3cb0fd, #3498db);
		background-image: -o-linear-gradient(top, #3cb0fd, #3498db);
		background-image: linear-gradient(to bottom, #3cb0fd, #3498db);
		text-decoration: none;
	}

	.fancy {
		font-size: 2.5rem;
		font-family: 'Kiwi Maru', serif;
	}

	.scroll-down {
		position: absolute;
		bottom: 2.5rem;
		left: 50%;
		transform: translateX(-50%);
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.scroll {
		width: 2rem;
		height: 4rem;
		border: 2px solid white;
		border-radius: 2rem;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.scroll span {
		width: 0.8rem;
		height: 0.8rem;
		border-radius: 50%;
		background: white;
		display: block;
		animation: cursor 1.15s linear infinite;
	}

	.allow-down {
		width: 0.8rem;
		height: 0.8rem;
		border: 2px solid transparent;
		border-right-color: white;
		border-bottom-color: white;
		transform: rotate(45deg);
		margin-top: 0.3rem;
		animation: allow 1.15s linear infinite;
	}

	@keyframes cursor {
		0% {
			opacity: 0;
			transform: translateY(-1rem);
		}

		100% {
			opacity: 1;
			transform: translateY(1rem);
		}
	}

	@keyframes allow {
		0% {
			opacity: 0;
		}

		25% {
			opacity: 0.25;
		}

		50% {
			opacity: 0.5;
		}

		75% {
			opacity: 0.75;
		}

		100% {
			opacity: 1;
		}
	}
	/* video */
	.video{
		width: 100%;
		height: 100vh;
		background: url(/doremi_dance.png) no-repeat center/cover;
		position: absolute;
		top: 0;
		left: 0;
		overflow: hidden;
		z-index: -1;
	}

	.video::after{
		content: '';
		width: 100%;
		height: 100%;
		background-color: #10394b;
		display: block;
		position: absolute;
		left: 0;
		top: 0;
		opacity: .3;
	}

	.video video{
		min-width: 100%;
		min-height: 100%;
		width: auto;
		height: auto;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translateX(-50%) translateY(-50%);
	}
</style>